import encrypt from "./encrypt";
import { gptDomain } from "@/config/apiDomain";

const sleep = (delay: number) => {
  return new Promise((resolve) => setTimeout(resolve, delay));
};

const getFormatTime = (time: any) => {
  let t = new Date(time) || new Date();
  let tf = function (i: number) {
    return (i < 10 ? "0" : "") + i;
  };
  // @ts-ignore
  return "yyyy-MM-dd HH:mm:ss".replace(/yyyy|MM|dd|HH|mm|ss/g, (a: string) => {
    switch (a) {
      case "yyyy":
        return tf(t.getFullYear());
      case "MM":
        return tf(t.getMonth() + 1);
      case "dd":
        return tf(t.getDate());
      case "HH":
        return tf(t.getHours());
      case "mm":
        return tf(t.getMinutes());
      case "ss":
        return tf(t.getSeconds());
    }
  });
};

const base64ToFile = (base64: string) => {
  var arr: any = base64.split(",");
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], "base64ToFile.jpg", { type: mime });
};

const base64ToBlob = (base64: string) => {
  var byteString = atob(base64.split(",")[1]);
  var mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

const blobToFile = (blob: any) => {
  return new File([blob], "blobToFile.png", { type: "image/jpeg" });
};

const pathToBase64 = (path: string) => {
  return new Promise((resolve) => {
    // 创建一个临时canvas元素
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // 加载图片
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = path;

    // 图片加载完成后进行切割
    image.onload = async () => {
      // 设置canvas的宽高为图片的四等份大小
      const w = image.width;
      const h = image.height;
      canvas.width = w;
      canvas.height = h;
      if (!ctx) return;
      ctx.drawImage(image, 0, 0, w, h, 0, 0, w, h); // 第一个切割部分
      const newPath = canvas.toDataURL();
      resolve(newPath);
    };
  });
};

//文件大小转换
function renderByteSize(
  fileSize: number
  // type: "KB" | "MB" | "GB" | "TB" | "PB" | "EB" | "ZB" | "YB"
) {
  if (!fileSize) {
    return {
      renderStr: `0`,
      size: 0,
      unit: "",
    };
  }
  var unitArr = new Array("B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
  var index = 0;
  var srcsize = parseFloat(`${fileSize}`);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  if (index < 0) {
    index = 0;
  } else if (index > unitArr.length - 1) {
    index = unitArr.length - 1;
  }
  var size = srcsize / Math.pow(1024, index);
  size = +size.toFixed(2); //保留的小数位数
  return {
    renderStr: `${size}${unitArr[index]}`,
    size,
    unit: unitArr[index],
  };
}

const addQueryToUrl = function (param: any, url: string) {
  // 判断是否有问号
  if (url.indexOf("?") !== -1) {
    url += "&";
  } else {
    url += "?";
  }
  for (let key in param) {
    if (["", null, undefined].includes(param[key])) continue;
    // 获取 ？ 后的参数，如果有重复的，去除
    let paramsUrl = url.split("?")[1];
    if (paramsUrl.indexOf(key) > -1) continue;

    url = url + `${key}=${param[key]}&`;
  }
  return url.slice(0, -1);
};

/**
 * 1. 全部 url 的 请求参数，改到 body data 中
 */
const addFetchEncrypt = (requestArgs: any) => {
  const isFormData = (header: any) => {
    return header["Content-Type"] === "multipart/form-data";
  };

  const url = requestArgs.url;
  const data = requestArgs.data;
  const header = requestArgs.header;
  const enctyptList = [gptDomain];
  const result =
    requestArgs.needEncrypt || enctyptList.find((item) => url?.includes(item));
  // 取出参数数组
  const query = url
    .replace(/#\/$/, "")
    .replace(/(.*)\?/g, "")
    .split("&")
    .map((item: any) => item.split("="));
  // 1.如果不需要加密，直接返回 url 对象
  // 2.如果没有参数
  // 3. 如果是formData类型 'Content-Type': 'multipart/form-data',
  if (!result || query.length === 0 || isFormData(header))
    return {
      url,
      data,
      header,
    };

  // 取出原本的url
  let newUrl = url.replace(/#\/$/, "").replace(/\?(.*)/g, "");
  const urlDataObj: any = {};
  query.forEach((item: any) => {
    const [key, value] = item;
    urlDataObj[key] = value;
    if (key === "ekey") {
      newUrl = addQueryToUrl({ ekey: value }, newUrl);
    }
  });
  if (Object.entries(urlDataObj).length > 0) {
    newUrl = addQueryToUrl(
      { query_data: encodeURIComponent(encrypt(urlDataObj)) },
      newUrl
    );
  }
  return {
    url: newUrl,
    data: data
      ? {
          query_data: encrypt(data),
        }
      : data,
    header: {
      ...header,
      "Content-Type": header["Content-Type"]
        ? header["Content-Type"]
        : "application/json",
    },
  };
};

const isColor = (value: string) => {
  // 检查值是否为有效的颜色代码
  const s = new Option().style;
  s.color = value;
  return s.color !== "";
};

export {
  sleep,
  getFormatTime,
  pathToBase64,
  base64ToFile,
  base64ToBlob,
  blobToFile,
  renderByteSize,
  addFetchEncrypt,
  isColor,
};
